/**
 * WhatsApp takeover message templates for conversation handoff from Paul.
 */

/**
 * @param {string} [fullName]
 * @returns {string}
 */
export function extractFirstName(fullName) {
  const trimmed = fullName?.trim();
  if (!trimmed) return "";
  return trimmed.split(/\s+/)[0];
}

/**
 * @param {Object} params
 * @param {string} [params.customerName]
 * @param {string} [params.opsName]
 * @returns {string}
 */
export function generateConversationTakeoverMessage({
  customerName,
  opsName,
}) {
  const greetingName = extractFirstName(customerName) || "there";
  const opsDisplayName = opsName?.trim() || "your Bubakii advisor";

  return `Hi ${greetingName}!

My name is ${opsDisplayName}, and I've taken over from our assistant, Paul. I will assist you directly from now on.

I see you've already submitted some details. Please give me a moment to review them.

I will respond soon.

${opsDisplayName}`;
}
